import { updateDiscoveryRule } from '@process-advisor/process-miner/processMiner/processMiner';

export type Props = {
    discoveryRule?: any;
    discovery_rule?: any;
    savedDiscoveryRuleID?: any;
    source?: any;

}

export async function processDiscoveryRule ({discoveryRule, discovery_rule, savedDiscoveryRuleID, source}: Props) {
    const rule = discoveryRule ?? discovery_rule;
    await updateDiscoveryRule(rule, savedDiscoveryRuleID, source);
}

